import { render, staticRenderFns } from "./artist_info.vue?vue&type=template&id=164b2abd&"
import script from "./artist_info.vue?vue&type=script&lang=js&"
export * from "./artist_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports